import React from 'react';
import { Container, Grid, Paper } from '@material-ui/core';
import { FormattedMessage, injectIntl } from 'react-intl';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS2 } from '../../constants';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles(() => ({
    description: {
        width: '100%',
        marginTop: '0.5rem',
        textAlign: 'center',
    },
    customH2Header: {
        lineHeight: '2rem',
        fontSize: '2rem',
        color: 'white',
        fontWeight: 400,
    },
    topButtons: {
        border: '1px solid rgba(6, 81, 86, 0.24)',
        borderRadius: '1rem',
        height: '4.5rem',
        backgroundColor: 'rgba(6, 81, 86, 0.08)',
        boxShadow: 'none',
        color: COLORS2.darkGreen,
        width: '23rem',
    },
    customH2HeaderLoggedIn: {
        lineHeight: '2rem',
        fontSize: '2rem',
        color: COLORS2.darkGreen,
        fontWeight: 400,
    },
    customH2: {
        color: 'white',
        fontWeight: 700,
    },
    customH2LoggedIn: {
        color: COLORS2.darkGreen,
        fontWeight: 700,
    },
    alignWidth: {
        width: '100%',
        textAlign: 'center',
        marginTop: '1rem',
    },
}));

const SubscriptionsDigitaliada = () => {
    const classes = useStyles();


    return (
        <>
            <Container maxWidth='lg'>
                <div style={{ zIndex: '1', paddingBottom: '5rem' }}>
                    <Typography variant='h1'>
                        <b>VBoard - integrare cu digitaliada</b>
                    </Typography>
                    <Divider style={{ margin: '1rem' }} />
                    <Typography variant='h4'>
                        Această secțiune utilizează aplicația interactivă vBoard, oferind profesorilor acces la o tablă
                        digitală modernă și ușor de folosit.
                    </Typography>
                    <Divider style={{ margin: '1rem' }} />
                    <Typography variant='h4'>
                        Funcționalitatea utilizeaza versiunea gratuită și nu necesită părăsirea paginii.
                    </Typography>
                    <Divider style={{ margin: '1rem' }} />
                    <Typography variant='h4'>
                        <b>
                            Pentru activarea unor funcționalități suplimentare, opțiunea de Upgrade vă va redirecționa
                            către site-ul oficial vBoard, sau ne puteti scrie pe adresa
                            <br></br>
                            <br></br>
                            <div style={{ width: '100%', textAlign: 'center' }}><i>contact@vboard.ro</i></div>

                        </b>
                    </Typography>

                    <Divider style={{ margin: '1rem' }} />
                    <Typography variant='h4'>
                        <div style={{ width: '100%', textAlign: 'center' }}><a href={'https://vboard.ro'}
                                                                               target={'_blank'}>UPGRADE</a>
                        </div>
                    </Typography>
                    <Typography variant='h4'>
                        <div style={{ width: '100%', textAlign: 'center' }}><a href={'https://vboard.ro'}
                                                                               target={'_blank'}>vboard.ro</a>
                        </div>
                    </Typography>

                </div>
            </Container>
        </>
    );
};


export default injectIntl(SubscriptionsDigitaliada);
